import React from 'react'
import { AppShell, Header } from '@mantine/core'
import HeadHCT from '../HCT head/HeadHCT'
import { useMediaQuery } from '@mantine/hooks';
// import UserManagement from './UserManagement';
import MobileHead from '../HCT head/MobileHead';
import PageComponent from './PageComponent';
const HCTPageComp = () => {

    const mediumScreen = useMediaQuery("(min-width: 1200px)");
    const largeScreen = useMediaQuery("(min-width: 1440px)");
    const extraLargeScreen = useMediaQuery("(min-width: 1770px)");
    return (
        <div>
            <>
                {
                    mediumScreen ? (
                        <AppShell header={
                            <Header><HeadHCT /></Header>
                        }><PageComponent /></AppShell>
                    ) : (
                        <>
                            <PageComponent />
                            <MobileHead />
                        </>
                    )
                }
            </>
        </div>
    )
}

export default HCTPageComp
